import React, { useState } from "react";
import { Colorful, Wheel } from "@uiw/react-color";

const ModalCustomPallete = ({
  colorThemes,
  setColorThemes,
  setHandleColorTheme,
}) => {
  const [color1, setColor1] = useState(() => {
    if (colorThemes.length == 6) {
      return colorThemes[5].color1.toUpperCase();
    }
    return "#FF6500";
  });
  const [color2, setColor2] = useState(() => {
    if (colorThemes.length == 6) {
      return colorThemes[5].color2.toUpperCase();
    }
    return "#1E3E62";
  });
  const [optionState, setOptionState] = useState("custom");

  const handleOnChange = (e, funcSet) => {
    e.preventDefault();
    funcSet(e.target.value);
  };
  return (
    <dialog id="pallete_modal" className="modal shadow-2xl">
      <div className="modal-box w-fit p-5 md:p-10 h-fit">
        <form
          method="dialog"
          className="flex flex-row justify-between items-center"
        >
          <h3 className="text-lg font-bold text-black">Custom Pallete</h3>
          <button className="btn btn-sm btn-circle btn-ghost">✕</button>
        </form>
        <div className="flex flex-col gap-5 mt-5">
          <div className="flex flex-col md:flex-row gap-5">
            <div className="flex flex-col gap-2">
              <div className="font-bold text-black">Primary Color</div>
              <div className="flex flex-col w-full justify-center items-center gap-2">
                <Colorful
                  color={color1}
                  onChange={(color) => {
                    setColor1(color.hex);
                  }}
                  disableAlpha={true}
                  style={{ width: "100%" }}
                />
                <div className="flex flex-row border w-full rounded-lg justify-center items-center">
                  <div className="text-center w-1/4">HEX</div>
                  <input
                    className="flex justify-center items-center p-2 w-full rounded-r-lg text-black border-l-2 border-l-gray-200 text-center"
                    type="text"
                    value={color1}
                    onChange={(e) => {
                      handleOnChange(e, setColor1);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="font-bold text-black">Secondary Color</div>
              <div className="flex flex-col w-full justify-center items-center gap-2">
                <Colorful
                  color={color2}
                  onChange={(color) => {
                    setColor2(color.hex);
                  }}
                  disableAlpha={true}
                  style={{ width: "100%" }}
                />
                <div className="flex flex-row border w-full rounded-lg justify-center items-center">
                  <div className="text-center w-1/4">HEX</div>
                  <input
                    className="flex justify-center items-center p-2 w-full rounded-r-lg text-black border-l-2 border-l-gray-200 text-center"
                    type="text"
                    value={color2}
                    onChange={(e) => {
                      handleOnChange(e, setColor2);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            className={`flex flex-col w-full items-center py-3 gap-3 rounded-md`}
          >
            <div className="flex flex-row w-full h-10">
              <div
                className="flex w-1/2"
                style={{ backgroundColor: color1 }}
              ></div>
              <div
                className="flex w-1/2"
                style={{ backgroundColor: color2 }}
              ></div>
            </div>
          </div>
          <form method="dialog">
            <button
              className="btn w-full p-2 rounded-lg text-center bg-secondary text-white cursor-pointer hover:bg-primary"
              onClick={(e) => {
                if (colorThemes.length < 6) {
                  setColorThemes([
                    ...colorThemes,
                    { color1: color1, color2: color2, name: "Custom" },
                  ]);
                } else {
                  setColorThemes([
                    ...colorThemes.slice(0, 5),
                    { color1: color1, color2: color2, name: "Custom" },
                  ]);
                }
                setHandleColorTheme(5, color1, color2);
              }}
            >
              SUBMIT
            </button>
          </form>
        </div>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button>close</button>
      </form>
    </dialog>
  );
};

export default ModalCustomPallete;
